(function() {
    'use strict';
    angular
        .module('mVtasWebApp')
        .factory('Estadoactual', Estadoactual);

    Estadoactual.$inject = ['$resource', 'DateUtils'];

    function Estadoactual ($resource, DateUtils) {
        var resourceUrl =  'api/estadoactuals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.fechacontrol = DateUtils.convertDateTimeFromServer(data.fechacontrol);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
